<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" translate>INCLUDED_ITEMS</h4>
  <button type="button" class="close" aria-label="Close" (click)="crossClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <car-liner-included-items-by-ids
    [productIds]="includedItemIds"
    [parentId]="product.id"
  ></car-liner-included-items-by-ids>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary ml-auto" (click)="crossClick()" translate>CLOSE</button>
</div>
